"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deleteMailListRows_1 = require("./deleteMailListRows");
function emptySearchTableView(tableView) {
    return deleteMailListRows_1.default(tableView.rowKeys, tableView.id, false /* isExplicitSoftDelete */);
}
exports.default = emptySearchTableView;
//# sourceMappingURL=emptySearchTableView.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/emptySearchTableView.js
// module id = 5652
// module chunks = 62